export enum RequestStatus {
  NOT_LOADED,
  LOADING,
  LOADED,
  ERROR,
}

export enum TransactionsStatus {
  COMPLETED = "Completed",
  PENDING = "Pending",
  CANCELED = "Canceled",
  ERROR = "Error",
}

export enum LINK_ERROR_CODE {
  INVALID_TOKEN = "INVALID_TOKEN",
  LINK_NOT_FOUND = "LINK_NOT_FOUND",
  LINK_EXPIRED = "LINK_EXPIRED",
  LINK_REVOKED = "LINK_REVOKED",
  LINK_ALREADY_USED = "LINK_ALREADY_USED",
  SESSION_NOT_STARTED = "SESSION_NOT_STARTED",
  RATE_LIMITED = "RATE_LIMITED",
  SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE",
  SERVICE_UNAVAILABLE_MAINTENANCE = "SERVICE_UNAVAILABLE_MAINTENANCE",
  INTERNAL_ERROR = "INTERNAL_ERROR",
}
